// Razorpay's checkout script, which react-razorpay's `new Razorpay()` wraps
// (window.Razorpay). The hook loads it once on page load and never again, so
// if that load was blocked (an ad / tracker blocker, a network blip) checkout
// failed with "window.Razorpay is not a constructor". Loaded again on demand
// before an order is created, so a failure is a clear message, not a dead order.
export const CHECKOUT_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

export const CHECKOUT_UNAVAILABLE_MESSAGE =
    "Couldn't load the payment window. Check your internet connection, turn off any ad blocker for this site, then try again.";

let loading = null;

// Resolves true once window.Razorpay exists, false if the script can't load
export const loadRazorpayCheckout = (timeoutMs = 15000) => {
    if (typeof window === 'undefined') return Promise.resolve(false);
    if (window.Razorpay) return Promise.resolve(true);
    if (loading) return loading;
    loading = new Promise((resolve) => {
        const script = document.createElement('script');
        const done = (ok) => {
            clearTimeout(timer);
            loading = null;
            if (!ok) script.remove();
            resolve(ok && !!window.Razorpay);
        };
        const timer = setTimeout(() => done(false), timeoutMs);
        script.src = CHECKOUT_SCRIPT_URL;
        script.async = true;
        script.onload = () => done(true);
        script.onerror = () => done(false);
        document.body.appendChild(script);
    });
    return loading;
};
